export const PERMISSION_ACTIONS = ["view", "create", "edit", "delete"];

export const PERMISSION_MODULES = [
  ["dashboard", "Panel"],
  ["tasks", "Görevler"],
  ["notifications", "Bildirimler / Sohbet"],
  ["warehouse_stock", "Depo / Stok"],
  ["warehouse_costs", "Depo / Alış Maliyetleri"],
  ["warehouse_movements", "Depo / Stok Hareketleri"],
  ["warehouse_recipes", "Depo / Reçeteler"],
  ["warehouse_assets", "Depo / Demirbaşlar"],
  ["warehouse_settings", "Depo / Barkod Ayarları"],
  ["warehouse_reports", "Depo / Raporlar"],
  ["warehouse_returns", "Depo / İadeler & Hasarlı Ürünler"],
  ["warehouse_counts", "Depo / Stok Sayım"],
  ["ecommerce_profit", "E-Ticaret Kâr Hesapla"],
  ["marketplace_price", "Pazaryeri Fiyat Yönetimi"],
  ["profit_loss", "Kâr / Zarar"],
  ["financial_archive", "Finansal Arşiv / Grafikler"],
  ["accounting_control", "Muhasebe Kontrol Merkezi"],
  ["business_expenses", "İşletme Giderleri"],
  ["employees", "Çalışanlar / Personel ve Özlük"],
  ["employees_sensitive", "Çalışanlar / Hassas Özlük ve Ücret Bilgileri"],
  ["b2b", "B2B Satış"],
  ["order_requests", "Sipariş Talep"],
  ["users", "Kullanıcılar / Yetkiler"],
  ["documents", "Document"],
];

const USER_DEFAULTS = {
  dashboard: { view: true },
  tasks: { view: true, create: true, edit: true },
  notifications: { view: true, create: true, edit: true },
  documents: { view: true },
  warehouse_costs: { view: false },
  employees_sensitive: { view: false },
};

export function hasPermissionFor(user, module, action = "view") {
  if (!user) return false;
  if (["admin", "super_admin"].includes(user.role)) return true;
  const custom = user.permissions;
  if (custom && typeof custom === "object" && Object.prototype.hasOwnProperty.call(custom, module)) {
    return !!custom?.[module]?.[action];
  }
  return !!USER_DEFAULTS?.[module]?.[action];
}

export function emptyPermissions() {
  return Object.fromEntries(PERMISSION_MODULES.map(([key]) => [key, { view: false, create: false, edit: false, delete: false }]));
}

export function normalizedPermissions(value = {}) {
  const out = emptyPermissions();
  for (const [module] of PERMISSION_MODULES) {
    const hasExplicit = value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, module);
    const src = value?.[module] || {};
    out[module] = {
      view: hasExplicit ? !!src.view : !!USER_DEFAULTS?.[module]?.view,
      create: hasExplicit ? !!src.create : !!USER_DEFAULTS?.[module]?.create,
      edit: hasExplicit ? !!src.edit : !!USER_DEFAULTS?.[module]?.edit,
      delete: hasExplicit ? !!src.delete : !!USER_DEFAULTS?.[module]?.delete,
    };
    if (out[module].create || out[module].edit || out[module].delete) out[module].view = true;
  }
  return out;
}
